import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-629a68b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fgc-admin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "FGC Event Admin", -1))
const _hoisted_3 = { class: "current-total" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Current Total:", -1))
const _hoisted_5 = { class: "button-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Donor"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Message"),
    /*#__PURE__*/_createElementVNode("th", null, "Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_7 = { class: "action-buttons" }
const _hoisted_8 = {
  key: 0,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_card, {
      class: "admin-card",
      elevation: "4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode("Event Controls")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" $" + _toDisplayString(_ctx.currentTotal.toFixed(2)), 1)
            ]),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.newTotal,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newTotal) = $event)),
              label: "Update Total",
              type: "number",
              step: "0.01",
              class: "mt-4"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_btn, {
                color: "primary",
                onClick: _ctx.updateTotal
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Update Total")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                color: "error",
                onClick: _ctx.confirmReset
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Reset Event")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "admin-card",
      elevation: "4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode("Donations Management")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donations, (donation) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: donation.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(donation.donor_name), 1),
                      _createElementVNode("td", null, "$" + _toDisplayString(donation.amount), 1),
                      _createElementVNode("td", null, _toDisplayString(donation.message || '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(donation.created_at)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            color: "primary",
                            onClick: ($event: any) => (_ctx.openEdit(donation))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Edit ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            size: "small",
                            color: "error",
                            onClick: ($event: any) => (_ctx.confirmDelete(donation.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Delete ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            (_ctx.donations.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No donations yet "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.resetDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.resetDialog) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Confirm Reset")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to reset the event? This will create a new event with $250 starting total. Previous donations will remain in the database but won't be displayed. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  onClick: _ctx.resetEvent
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Reset")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editDialog) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Edit Donation")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.editForm.donor_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editForm.donor_name) = $event)),
                  label: "Donor Name",
                  class: "mb-2"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.editForm.amount,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editForm.amount) = $event)),
                  label: "Amount",
                  type: "number",
                  prefix: "$",
                  step: "0.01",
                  class: "mb-2"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.editForm.message,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editForm.message) = $event)),
                  label: "Message",
                  rows: "2",
                  "auto-grow": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _ctx.saveEdit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Confirm Delete")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to delete this donation? The total will be adjusted accordingly. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  onClick: _ctx.deleteDonation
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Delete")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.snackbar) = $event)),
      color: _ctx.snackbarColor
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackbarText), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}